<template>
  <div v-if="isDeviceLoaded">
    <div class="columns is-mobile optionsContainer">
      <div
          class="column"
          style="cursor: pointer"
          @click="
          $router.push(
            '/installations/' +
              installation['.key'] +
              '/zone/' +
              zone.path.split('/')[zone.path.split('/').length - 1] +
              '/device/' +
              device.serialnumber +
              '/edit'
          )
        "
          v-bind:class="getDeviceTemperatureColorBackground(device, schedule)"
      >
        <span class="icon clickable">
          <i class="mdi mdi-pencil"></i>
        </span>
      </div>

      <div
          class="column"
          style="cursor: pointer"
          @click="
          $router.push(
            '/installations/' +
              installation['.key'] +
              '/zone/' +
              zone.path.split('/')[zone.path.split('/').length - 1] +
              '/device/' +
              device.serialnumber +
              '/info'
          )
        "
          v-bind:class="getDeviceTemperatureColorBackground(device, schedule)"
      >
        <span class="icon clickable">
          <i class="mdi mdi-information-outline"></i>
        </span>
      </div>
      <div
          class="column"
          style="cursor: pointer"
          v-if="!isFloor"
          @click="
          $router.push(
            '/installations/' +
              installation['.key'] +
              '/zone/' +
              zone.path.split('/')[zone.path.split('/').length - 1] +
              '/device/' +
              device.serialnumber +
              '/settings'
          )
        "
          v-bind:class="getDeviceTemperatureColorBackground(device, schedule)"
      >
        <img src="/home/images/zones/btn_ajustes.png"/>
      </div>

      <!--      <div-->
      <!--        class="column"-->
      <!--        style="cursor: pointer"-->
      <!--        v-if="!isFloor"-->
      <!--        @click="-->
      <!--          $router.push(-->
      <!--            '/installations/' +-->
      <!--              installation['.key'] +-->
      <!--              '/zone/' +-->
      <!--              zone.path.split('/')[zone.path.split('/').length - 1] +-->
      <!--              '/device/' +-->
      <!--              device.serialnumber +-->
      <!--              '/program'-->
      <!--          )-->
      <!--        "-->
      <!--        v-bind:class="getDeviceTemperatureColorBackground(device)"-->
      <!--      >-->
      <!--        <span class="icon clickable">-->
      <!--          <i class="mdi mdi-clock"></i>-->
      <!--        </span>-->
      <!--      </div>-->

      <!--      <div-->
      <!--        class="column"-->
      <!--        style="cursor: pointer"-->
      <!--        v-if="!isFloor"-->
      <!--        @click="goToStatistics()"-->
      <!--        v-bind:class="getDeviceTemperatureColorBackground(device)"-->
      <!--      >-->
      <!--        <span class="icon clickable">-->
      <!--          <i class="mdi mdi-chart-bar"></i>-->
      <!--        </span>-->
      <!--      </div>-->
    </div>
    <device-thermostat
        id="thermostat"
        :schedule="schedule"
        v-bind:class="getDeviceTemperatureColorBackground(device, schedule)"
    ></device-thermostat>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import colors from "@/mixins/colors";

import DeviceThermostat from "../../../../components/installations/devices/DeviceThermostat";
import constants from "../../../../config/constants";

export default {
  components: {DeviceThermostat},
  name: "device",
  mixins: [colors],
  props: {
    idDevice: String,
  },
  data() {
    return {
      isDeviceLoaded: false,
      schedule: [],
    };
  },

  computed: {
    ...mapState("installations", {
      installation: "current",
      tariff: "currentTariff",
    }),

    ...mapState("zones", {
      zone: "current",
    }),

    ...mapState("devices", {
      device: "current",
    }),

    isFloor: function () {
      return this.device.data.type === constants.deviceTypes.floor;
    },
  },
  methods: {
    ...mapActions("installations", {
      setInstallation: "setCurrent",
      setZone: "setCurrentZone",
      setDevice: "setCurrentDevice",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
    }),

    ...mapActions("devices", {
      setDevice: "setCurrent",
      getDeviceSchedule: "getDeviceSchedule",
    }),

    // goToStatistics: function () {
    //   let hasTariff = this.tariff.filter((hour) => hour > 0).length > 0;
    //
    //   if (hasTariff) {
    //     this.$router.push(
    //       "/installations/" +
    //         this.installation[".key"] +
    //         "/zone/" +
    //         this.zone.path.split("/")[this.zone.path.split("/").length - 1] +
    //         "/device/" +
    //         this.device.serialnumber +
    //         "/statistics"
    //     );
    //   } else {
    //     this.$dialog.alert(this.$t("statistics.noTariff"));
    //   }
    // },

    loadDevice: function () {
      this.setInstallation(this.$route.params.id)
          .then(() => {
            this.setZone(this.$route.params.idZone).then(() => {
              this.setDevice(this.$route.params.idDevice).then(
                  async () => {
                    this.schedule = await this.getDeviceSchedule({device: this.device});
                    this.isDeviceLoaded = true
                  }
              );
            });
          })
          .catch(() => {
            this.$router.push("/installations");
          });
    },

    goParent() {
      this.$router.push(
          "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1]
      );
    },
  },
  async created() {
    this.loadDevice();
  }
};
</script>

<style lang="scss" scoped>
.is-main-content > div {
  height: 100%;
}

.optionsContainer {
  color: white;
  float: right;
  margin: 0rem 0 0 0;
  height: 3rem;

  .column {
    .icon .mdi {
      font-size: 22px;
    }

    width: 60px;
    flex-basis: 240px;
  }

  .column.active {
    opacity: 1;
  }

  img {
    height: 100%;
    /*padding: 0 30% 0 0;*/
  }
}
</style>
